<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Redigera tåg avvikelse
      </v-card-title>

      <v-card-text class="mt-2">
        <TrainDeviationActivitySearch :edit-mode="true" />
        <v-row>
          <TrainDeviationDeviationTypeField />
        </v-row>
        <TrainDeviationDepartureFields />
        <TrainDeviationArrivalFields />
        <TrainDeviationError v-if="isErrorArrivalBeforeDeparture">
          Ankomsttiden får inte vara innan avgångstiden!
        </TrainDeviationError>

        <TrainDeviationError v-if="isErrorSamePlaces">
          Ankomstplatsen får ej vara samma som avgångsplatsen!
        </TrainDeviationError>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending">
          Redigera tåg avvikelse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync, get } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import TrainDeviationActivitySearch from './TrainDeviationForm/TrainDeviationActivitySearch'
import TrainDeviationDeviationTypeField from './TrainDeviationForm/TrainDeviationDeviationTypeField'
import TrainDeviationDepartureFields from './TrainDeviationForm/TrainDeviationDepartureFields'
import TrainDeviationArrivalFields from './TrainDeviationForm/TrainDeviationArrivalFields'
import TrainDeviationError from './TrainDeviationForm/TrainDeviationError'

export default {
  name: 'TrainDeviationEditModal',

  components: {
    TrainDeviationActivitySearch,
    TrainDeviationArrivalFields,
    TrainDeviationDepartureFields,
    TrainDeviationDeviationTypeField,
    TrainDeviationError
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (['departure', 'arrival'].includes(key)) {
        acc[key] = new Date(this.item[key])
      } else if (key === 'uuid') {
        acc[key] = this.model[key]
      } else if (
        key === 'from' &&
        this.item.type === 'RST' &&
        this.departurePlaces.length
      ) {
        acc[key] = `${this.item[key]}_${this.item.departure}`
      } else if (
        key === 'to' &&
        this.item.type === 'RST' &&
        this.arrivalPlaces.length
      ) {
        acc[key] = `${this.item[key]}_${this.item.arrival}`
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})
    this.$store.set('trainDeviation/model', updateModel)
  },

  computed: {
    model: sync('trainDeviation/model'),
    arrivalPlaces: get('trainDeviation/arrivalPlaces'),
    departurePlaces: get('trainDeviation/departurePlaces'),

    isErrorArrivalBeforeDeparture() {
      return (
        new Date(this.model.arrival).getTime() <
        new Date(this.model.departure).getTime()
      )
    },

    isErrorSamePlaces() {
      return (
        this.model.from &&
        this.model.to &&
        this.model.from === this.model.to &&
        new Date(this.model.arrival).getTime() ===
          new Date(this.model.departure).getTime()
      )
    }
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm || this.isError) return
      this.updatePending = true

      const model = {
        ...this.model,
        from: this.model.from.includes('_')
          ? this.model.from.split('_')[0]
          : this.model.from,
        to: this.model.to.includes('_')
          ? this.model.to.split('_')[0]
          : this.model.to
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceTrainDeviationInput!) {
            replaceTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload: model
          }
        }
      })
      this.$store.set(`trainDeviation/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`trainDeviation/data@${model.uuid}`, model)

      this.updatePending = false
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('trainDeviation/resetModel')
      this.$emit('close')
    }
  }
}
</script>
